import { Component, Input, OnInit } from '@angular/core'

const DEFAULT_CLASSES = {
  JML_CRUD_BUTTON: 'jml-crud-button',
  CRUD_BUTTON: 'crud-button',
  NO_HOVER: 'no-hover'
}

type TooltipPositionsTypes = 'top' | 'bottom' | 'left' | 'right'

@Component({
  selector: 'icon-action-button',
  templateUrl: './icon.action.button.html',
  styleUrls: ['./icon.action.button.scss']
})
export class IconActionButton implements OnInit {
  @Input() icon: string = ''
  @Input() additionalClassNames: string = ''
  @Input() tooltip: string = ''
  @Input() tooltipEnabled: boolean = true
  @Input() hoverEnabled: boolean = true
  @Input() tooltipPosition: TooltipPositionsTypes = 'top'
  public allClasses: string = ''

  ngOnInit() {
    this.initClasses()
  }

  private initClasses() {
    const hoverClass: string = this.hoverEnabled ? '' : DEFAULT_CLASSES.NO_HOVER
    const additionalClasses: string = this.additionalClassNames || ''
    this.allClasses = [
      DEFAULT_CLASSES.CRUD_BUTTON,
      DEFAULT_CLASSES.JML_CRUD_BUTTON,
      hoverClass,
      additionalClasses
    ].join(' ')
  }
}
